<div class="loading-shade" *ngIf="visibleSpinner">
  <mat-spinner></mat-spinner>
</div>
